module.exports = __webpack_public_path__ + "img/logo_new.0ccd92e5.png";